export enum EnumProjectType {
  Active = 0,
  Archived = 1,
}
